import { supabase } from "@/integrations/supabase/client";

export const GOOGLE_ADS_REDIRECT_PATH = "/google-ads-callback";

export const buildGoogleAdsRedirectUri = () =>
  `${window.location.origin}${GOOGLE_ADS_REDIRECT_PATH}`;

/**
 * Starts the Google Ads OAuth flow without disturbing the Supabase session.
 */
export async function startGoogleAdsOAuth(): Promise<{ redirectUri: string }> {
  const { data: auth } = await supabase.auth.getUser();
  const uid = auth.user?.id;
  if (!uid) throw new Error("You must be logged in to connect Google Ads.");

  const redirectUri = buildGoogleAdsRedirectUri();
  console.log("[GoogleAdsOAuth] redirect_uri being sent to Google:", redirectUri);
  console.log("[GoogleAdsOAuth] This EXACT string (no trailing slash) must be in Google Cloud → OAuth Client → Authorized redirect URIs.");

  const { data, error } = await supabase.functions.invoke("start-google-ads-oauth", {
    body: { redirectUri },
  });

  const payload: any = data;
  if (error || !payload?.ok || !payload?.url) {
    throw new Error(payload?.error || error?.message || "Could not start Google Ads OAuth flow.");
  }

  console.log("[GoogleAdsOAuth] Full Google consent URL:", payload.url);
  window.location.href = payload.url;
  return { redirectUri };
}
